import { FileOrigin } from 'filepond'
import { setUploadedFiles } from './setUploadedFiles'

/**
 * @package     Image Hopper
 * @copyright   Copyright (c) 2021, Image Hopper
 * @license     http://opensource.org/licenses/gpl-2.0.php GNU Public License
 */

export function reorderFiles (files, fieldId, formId) {
  const reorderedFiles = []

  files.forEach((file) => {
    if (file.origin === FileOrigin.LOCAL) {
      reorderedFiles.push({
        temp_filename: '',
        uploaded_filename: file.serverId
      })
    } else {
      reorderedFiles.push({
        temp_filename: file.serverId,
        uploaded_filename: file.filename
      })
    }
  })

  setUploadedFiles(fieldId, reorderedFiles, formId)
}
